<template>
  <span></span>
</template>

<script>
import DefaultValue from './DefaultValue.vue'
export default {
  extends: DefaultValue
}
</script>
